import { palette } from 'src/styles/colors';
import { layout } from 'src/styles/layout';
import styled from 'styled-components';

export interface PolygonBlueProps {
  position: 'relative' | 'absolute';
  zIndex?: number;
}

export const PolygonBlueContainer = styled.div<PolygonBlueProps>`
  width: 100%;
  height: 100%;
  position: ${({ position }) => position};
  z-index: ${({ zIndex }) => zIndex || 1};
  background: ${palette.lightBlue};
  left: 0rem;
  top: 0rem;
  clip-path: polygon(89% 19%, 100% 47%, 100% 100%, 0 100%, 0 0);
  
  @media all and (max-width: ${layout.md}) {
    clip-path: polygon(93% 12%,100% 29%,100% 100%,0 100%,0 0);
  }
  @media all and (max-width: ${layout.xs}) {
    clip-path: polygon(88% 10%,100% 19%,100% 100%,0 100%,0% 6%);
  }
`
